import React from 'react';
import { Modal, Checkbox } from 'antd';
import { FormattedMessage } from 'react-intl';
import './style.scss';

interface IProps {
  visible: boolean;
  onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>, dontShowAgain: boolean) => void;
}

interface IState {
  dontShowAgain: boolean;
}

export class ModalAnytimeSearchWarning extends React.Component<IProps, IState> {
  state: IState = {
    dontShowAgain: true
  }

  onToggle = (): void => this.setState({ dontShowAgain: !this.state.dontShowAgain })

  render(): React.ReactNode {
    const {
      visible,
      onCancel
    } = this.props;

    const { dontShowAgain } = this.state;

    return (
      <Modal
        className="modal-anytime-search-warning"
        visible={visible}
        footer={null}
        onCancel={(e) => onCancel(e, dontShowAgain)}
        wrapClassName="modal-anytime-search-warning__wrapper"
        width={680}
      >
        <div>
          <div className="modal-anytime-search-warning__text">
            <i>
              <FormattedMessage id="modal.anytime.search.warning.text" />
            </i>
          </div>
          <div className="modal-anytime-search-warning__throttle">
            <Checkbox checked={dontShowAgain} onChange={this.onToggle}>
              <FormattedMessage id="modal.anytime.search.warning.throttle" />
            </Checkbox>
          </div>
        </div>
      </Modal>
    );
  }
}
